import { lazy, type ComponentType, type LazyExoticComponent } from 'react';
import type { Control, FieldValues } from 'react-hook-form';
import type { LinhaItem } from './EditorItens';

export type TelaRotina = LazyExoticComponent<ComponentType<{ codigo: string }>>;

export const telaSobDemanda = <K extends string>(
  carregar: () => Promise<Record<K, ComponentType<{ codigo: string }>>>,
  nome: K,
): TelaRotina => lazy(() => carregar().then((modulo) => ({ default: modulo[nome] })));

/** Ação extra no cabeçalho do detalhe de um registro, por código de rotina (`acoesDetalheRotina`). */
export type AcaoDetalhe = LazyExoticComponent<ComponentType<{ registro: { id: number } }>>;

export const acaoDetalheSobDemanda = <K extends string>(
  carregar: () => Promise<Record<K, ComponentType<{ registro: { id: number } }>>>,
  nome: K,
): AcaoDetalhe => lazy(() => carregar().then((modulo) => ({ default: modulo[nome] })));

/** Seção extra no detalhe do registro, abaixo dos itens (ex.: FAT060 "Valores e impostos"), por código de rotina (`secoesDetalheRotina`). */
export interface PropsSecaoDetalhe { registro: { id: number } }
export type SecaoDetalhe = LazyExoticComponent<ComponentType<PropsSecaoDetalhe>>;

/** Quadro ao vivo no formulário, abaixo dos itens (ex.: FAT060 totais e impostos enquanto os itens entram), por rotina (`resumosFormularioRotina`). */
export interface PropsResumoFormulario { control: Control<FieldValues>; itens: Record<string, LinhaItem[]> }
export type ResumoFormulario = LazyExoticComponent<ComponentType<PropsResumoFormulario>>;

/** Carrega sob demanda um componente nomeado de um módulo (seções e resumos por rotina). */
export const componenteSobDemanda = <P extends object, K extends string>(carregar: () => Promise<Record<K, ComponentType<P>>>, nome: K) =>
  lazy(() => carregar().then((modulo) => ({ default: modulo[nome] })));
